import { defineStore } from 'pinia';
import elementoTipoService from '@/services/elemento_tipo_service.js';

export const useElementoTipoStore = defineStore('elementoTipoStore', {
  state: () => ({
    productTypeList: [],
    elementoTipo: null,
    page: 1,
    filters: {},
    isLoading: false,
  }),
  getters: {
    getActiveProductTypeList: (state) => state.productTypeList.filter((item) => item.Activo),
    getActiveReducedProductTypeList() {
      return this.getActiveProductTypeList.map((item) => ({
        Codigo: item.Codigo,
        Descripcion: item.Descripcion,
      }));
    },
  },
  actions: {
    async findAllTipoProductoHTTP(params) {
      const result = await elementoTipoService.findAll({
        page: +this.page,
        ...this.filters,
        ...params,
      });
      if (result) {
        this.productTypeList.splice(0, this.productTypeList.length, ...result);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findAndReturnProcesosPorDefectoHTTP({ CodigoElementoTipo, Modulo }) {
      return await elementoTipoService.findProcesosPorDefecto(CodigoElementoTipo, Modulo);
    },
    async saveElementoTipo() {
      if (this.elementoTipo.Codigo) {
        return await this.updateElementoTipoHTTP();
      } else {
        return await this.createElementoTipoHTTP();
      }
    },
    async createElementoTipoHTTP() {
      return await elementoTipoService.create(this.elementoTipo);
    },
    async updateElementoTipoHTTP() {
      return await elementoTipoService.update(this.elementoTipo.Codigo, this.elementoTipo);
    },
    // async getAllDetailedHTTP() {
    //   this.isLoading = true
    //   try {
    //     const result = await elementoTipoService.getAllDetailed(0)
    //     if (result) {
    //       this.productTypeList = result
    //       this.isLoading = false
    //       return true
    //     }
    //     this.isLoading = false
    //     return false
    //   } catch (error) {
    //     this.isLoading = false
    //     throw error
    //   }
    // },
    async updateproductTypeListHTTP(codigoElementoTipo, data) {
      const index = this.productTypeList.findIndex((item) => item.Codigo === codigoElementoTipo);

      const formatedData = data.map((proceso) => ({
        CodigoProceso: proceso.Proceso.Codigo,
        CodigoSeccion: proceso.Seccion?.Codigo,
        CodigoRecurso: proceso.Recurso?.Codigo,
        // Manejo de la nueva estructura de categorías de materiales
        categoriasMateriales:
          proceso.CategoriasMaterial && Array.isArray(proceso.CategoriasMaterial)
            ? proceso.CategoriasMaterial.map((categoria) => ({
                CodigoMaterialCategoria: categoria.MaterialCategoria?.Codigo,
                materiales:
                  categoria.ElementoMateriales?.map((elementoMaterial) =>
                    elementoMaterial.Material
                      ? elementoMaterial.Material.Codigo
                      : elementoMaterial.Codigo,
                  ) || [],
              }))
            : [],
        // Mantener compatibilidad con estructura anterior
        codigosMateriales: proceso.Materiales
          ? proceso.Materiales.map((material) =>
              material.Material ? material.Material.Codigo : material.Codigo,
            )
          : [],
        PorDefecto: proceso.PorDefecto,
        AdmiteSuaje: proceso.AdmiteSuaje || false,
      }));

      const result = await elementoTipoService.updateProcesos(codigoElementoTipo, formatedData);
      if (result) {
        if (index !== -1) {
          this.productTypeList[index] = result.data;
        }
        return true;
      }
      return false;
    },
    setPage(page) {
      this.page = page;
    },
    async firstTipoProducto(page = 1) {
      this.setPage(page);
      this.emptyList();
      await this.findAllTipoProductoHTTP();
    },
    async resetElementoTipoList() {
      this.setPage(1);
      this.emptyList();
      await this.findAllTipoProductoHTTP();
    },
    emptyList() {
      this.productTypeList = [];
    },
  },
});
